import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { GrowthProfessions } from 'components/pages/Growth/parts/GrowthProfessions';

import { GrowthSectionLayout } from './GrowthSectionLayout';

/** /growth/professions — витрина профессий вместо `?tab=jobs`. */
export const GrowthProfessionList = memo(() => {
  const { t } = useTranslation();

  return (
    <GrowthSectionLayout
      title={t('growth.professions.title')}
      lead={t('growth.professions.pageLead')}>
      <GrowthProfessions />
    </GrowthSectionLayout>
  );
});
